export const BoldIcon = () => {
    return (
        <svg width={18} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-black dark:fill-white">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.766 7.059h.588a2.355 2.355 0 0 0 2.353-2.353 2.355 2.355 0 0 0-2.353-2.353H3.119v4.706h7.647ZM3.119 17.647h7.647a4.122 4.122 0 0 0 4.117-4.118 4.122 4.122 0 0 0-4.117-4.117H3.119v8.235ZM10.766 20h-10V0h10.588a4.71 4.71 0 0 1 4.706 4.706c0 1.4-.614 2.66-1.588 3.522a6.466 6.466 0 0 1 2.764 5.301A6.479 6.479 0 0 1 10.766 20Z"
            />
        </svg>
    );
};
